import { Component, Input } from '@angular/core';

@Component({
  selector: 'md-icon-button',
  template: require('./icon-button.component.html'),
  styles: [require('./icon-button.component.scss')]
})

export class IconButtonComponent {
  @Input() option;

}
